import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import english from "./translations/en";
import deutsch from "./translations/de";
import { lsLoad } from "./tools/Storage";
import StorageEnum from "./enums/Storage.enum";
import { getDefaultLanguageCode } from "./tools/ConfigurationReader";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { enUS, enGB, de } from "date-fns/locale";

const resources = {
  "en-US": english(),
  "en-GB": english(),
  "de-DE": deutsch(),
};

registerLocale("en-US", enUS);
registerLocale("en-GB", enGB);
registerLocale("de-DE", de);

const languageCode = lsLoad(StorageEnum.UserProfile)?.languageCode;

i18n.use(initReactI18next).init({
  resources,
  lng: languageCode ?? getDefaultLanguageCode(),
});

setDefaultLocale(languageCode ?? getDefaultLanguageCode());

export default i18n;
